import { SET_DEAL_DATA, SET_DEAL_SORT_ORDER, SET_DEAL_RESET_SORT, } from "./types";
const initialSort = {
    booking_date: "DESC",
    deal_id: "ASC",
    cr_party_name: "ASC",
    track: "ASC",
    max_est_incentive_amount: "ASC",
    sub_track: "ASC",
    ws_deal_id: "ASC",
};
/**
 * Initial state for active-deals slice.
 * Merged from dashboard and admin-portal so both apps can use the same reducer.
 */
const initialState = {
    deals_page: 1,
    deals_perpage: 20,
    isdealsLoading: true,
    total_deals: 0,
    deals_list: [],
    deals_list_refetch_force: false,
    deals_list_refetch: false,
    partner_filter_options: [],
    selectedPartner: null,
    statusFilter: [],
    isArchivedChecked: false,
    isPendingActivityChecked: false,
    confirm_deal_popup: false,
    disable_confirm_btn: false,
    dealData: {},
    confirmType: "",
    completeDealList: [],
    completeDealListOpen: false,
    deal_search: "",
    sort: { ...initialSort },
    disableDealDownload: false,
    checkKitPopStatus: false,
    selectKitItem: [],
    kitItems: [],
    kitPage: 1,
    kitPerPage: 10,
    kitTotal: 0,
    kitLoading: true,
    kitLoadError: null,
    wsActivityData: [],
    taskDetails: [],
    archiveArray: [],
    nextArchiveConfirmPopup: false,
    bulkArchiveItems: [],
    archiveData: [],
    nextBtnDisable: false,
    // Admin-portal specific
    countries: [],
    country_id: "",
    region_name: "",
    parentOrgList: [],
    parentOrgListLoading: false,
    selectedParentOrgKey: [],
    service_charge: "",
};
export default function activeDealsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_DEAL_DATA:
            return { ...state, ...action.payload };
        case SET_DEAL_SORT_ORDER: {
            const { column, newSortOrder } = action.payload;
            return {
                ...state,
                sort: Object.keys(state.sort).reduce((newSort, key) => {
                    newSort[key] = key === column ? newSortOrder : "";
                    return newSort;
                }, {}),
            };
        }
        case SET_DEAL_RESET_SORT:
            return {
                ...state,
                sort: { ...initialSort },
            };
        default:
            return state;
    }
}
